<template>
  <span :title="title" class="title">
    <vue-plyr :options="{controls: ['play'], iconUrl: `${$ncsConfig.app.relative_url_root}/images/plyr.svg`}">
      <audio :src="`${$ncsConfig.app.relative_url_root}/audio/${text.id}.mp3`" preload="none"/>
    </vue-plyr>
    {{ text.hablante }}
  </span>
</template>
<script>
  import map from 'lodash/map'

  export default {
    props: ['document', 'text', 'elements', 'matches'],
    computed: {
      title() {
        const fields = this.$ncsCsvElementFields(this.document, this.text, this.elements, this.matches)
        return map(fields, (v, k) => `${k}: ${v || ''}`).join('\n')
      }
    }
  }
</script>
